import { useEffect } from "react";
import type { YouTubePlayer } from "youtube-player/dist/types";

import { VideoPlayMode } from "~/components/scmp-youtube-video/enums";

/**
 * For supporting play youtube video when clicking preview image
 */
export const useManualPlayEffect = (
  videoPlayMode: VideoPlayMode,
  player: OrUndefined<YouTubePlayer>,
) => {
  useEffect(() => {
    if (!player || videoPlayMode !== VideoPlayMode.Manual) return;
    const handleManualPlay = async () => {
      const iframe = await player.getIframe();
      if (!iframe) return;
      try {
        void player.playVideo();
      } catch (error) {
        console.error("useManualPlayEffect playVideo", error);
      }
    };
    void handleManualPlay();
  }, [videoPlayMode, player]);
};
